<template>
    <div class="main-content">
        <!-- BradCrumb header Start-->
        <section class="inner-header-bg">
            <div class="container">
                <!-- Breadcrumb Start-->
                <div class="section-breadcrumb portfolio-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 justify-content-center align-self-center pb-2">
                                <div class="breadcrumb-content">
                                    <div class="title-section">
                                        <h1 class="title text-center text-white">Portfolio Three Column</h1>
                                    </div>
                                    <div class="breadcrumb-nav">
                                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                                            <li class="text-white">
                                                <i class="mdi mdi-home theme-light-color pr-2"></i>
                                                <a href="index.html">Home</a>
                                            </li>
                                            <li class="theme-light-color active">Portfolio</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Breadcrumb End -->
            </div>
        </section>
        <!-- BradCrumb header End -->
        <!-- Start Portfolio Area -->
        <section class="section portfolio-section" id="portfolio">
            <div class="container">
                <div class="section-title text-center z-index9">
                    <span>OUR PORTFOLIO</span>
                    <h2>Our Creative Portfolio</h2>
                </div>
                <div class="d-flex justify-content-center wow fadeIn" data-wow-duration="1s">
                    <ul id="portfolio-filter" class="portfolio-filter filters mt-4 p-0">
                        <li class="button-border list-inline-item">
                            <a href="#" data-filter="*" class="pill-button active">All</a>
                        </li>
                        <li class="button-border list-inline-item">
                            <a href="#" data-filter=".webdesign" class="pill-button">Web Design</a>
                        </li>
                        <li class="button-border list-inline-item">
                            <a href="#" data-filter=".mobiledesign" class="pill-button">Mobile Design</a>
                        </li>
                        <li class="button-border list-inline-item">
                            <a href="#" data-filter=".seo" class="pill-button">Seo</a>
                        </li>
                        <li class="button-border list-inline-item">
                            <a href="#" data-filter=".graphic" class="pill-button">Graphic</a>
                        </li>
                    </ul>
                </div>
                <div class="portfolio-items row no-gutters mt-4  wow fadeIn" data-wow-duration="1s">
                    <!-- Item 01 -->
                    <div class="col-md-4 col-sm-6 portfolio-item seo">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="assets/images/portfolio/01.jpg" class="img-fluid" alt="">
                                <div class="portfolio-icon d-flex align-items-center justify-content-center">
                                    <a href="assets/images/portfolio/big/01.jpg" class="js-zoom-gallery">
                                        <i class="mdi mdi-magnify-plus-outline"></i>
                                    </a>
                                </div>
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">My Work</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Item 02 -->
                    <div class="col-md-4 col-sm-6 portfolio-item graphic webdesign">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="assets/images/portfolio/02.jpg" class="img-fluid" alt="">
                                <div class="portfolio-icon d-flex align-items-center justify-content-center">
                                    <a href="assets/images/portfolio/big/02.jpg" class="js-zoom-gallery">
                                        <i class="mdi mdi-magnify-plus-outline"></i>
                                    </a>
                                </div>
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">My Work</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Item 03 -->
                    <div class="col-md-4 col-sm-6 portfolio-item webdesign graphic">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="assets/images/portfolio/03.jpg" class="img-fluid" alt="">
                                <div class="portfolio-icon d-flex align-items-center justify-content-center">
                                    <a href="assets/images/portfolio/big/03.jpg" class="js-zoom-gallery">
                                        <i class="mdi mdi-magnify-plus-outline"></i>
                                    </a>
                                </div>
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">My Work</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Item 04 -->
                    <div class="col-md-4 col-sm-6 portfolio-item mobiledesign webdesign">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="assets/images/portfolio/04.jpg" class="img-fluid" alt="">
                                <div class="portfolio-icon d-flex align-items-center justify-content-center">
                                    <a href="assets/images/portfolio/big/04.jpg" class="js-zoom-gallery">
                                        <i class="mdi mdi-magnify-plus-outline"></i>
                                    </a>
                                </div>
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">My Work</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Item 05 -->
                    <div class="col-md-4 col-sm-6 portfolio-item mobiledesign seo">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="assets/images/portfolio/05.jpg" class="img-fluid" alt="">
                                <div class="portfolio-icon d-flex align-items-center justify-content-center">
                                    <a href="assets/images/portfolio/big/05.jpg" class="js-zoom-gallery">
                                        <i class="mdi mdi-magnify-plus-outline"></i>
                                    </a>
                                </div>
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">My Work</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Item 06 -->
                    <div class="col-md-4 col-sm-6 portfolio-item mobiledesign">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="assets/images/portfolio/06.jpg" class="img-fluid" alt="">
                                <div class="portfolio-icon d-flex align-items-center justify-content-center">
                                    <a href="assets/images/portfolio/big/06.jpg" class="js-zoom-gallery">
                                        <i class="mdi mdi-magnify-plus-outline"></i>
                                    </a>
                                </div>
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">My Work</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Item 07 -->
                    <div class="col-md-4 col-sm-6 portfolio-item mobiledesign webdesign">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="assets/images/portfolio/07.jpg" class="img-fluid" alt="">
                                <div class="portfolio-icon d-flex align-items-center justify-content-center">
                                    <a href="assets/images/portfolio/big/07.jpg" class="js-zoom-gallery">
                                        <i class="mdi mdi-magnify-plus-outline"></i>
                                    </a>
                                </div>
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">My Work</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Item 08 -->
                    <div class="col-md-4 col-sm-6 portfolio-item webdesign graphic">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="assets/images/portfolio/08.jpg" class="img-fluid" alt="">
                                <div class="portfolio-icon d-flex align-items-center justify-content-center">
                                    <a href="assets/images/portfolio/big/08.jpg" class="js-zoom-gallery">
                                        <i class="mdi mdi-magnify-plus-outline"></i>
                                    </a>
                                </div>
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">My Work</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Item 09 -->
                    <div class="col-md-4 col-sm-6 portfolio-item seo">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="assets/images/portfolio/09.jpg" class="img-fluid" alt="">
                                <div class="portfolio-icon d-flex align-items-center justify-content-center">
                                    <a href="assets/images/portfolio/big/09.jpg" class="js-zoom-gallery">
                                        <i class="mdi mdi-magnify-plus-outline"></i>
                                    </a>
                                </div>
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">My Work</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Portfolio Area -->
    </div>
</template>
<script>
    //ISOTOP JS
    import '../assets/js/jquery.isotope.min.js';
    import * as ScrollMagic from "scrollmagic";
    import { TweenMax, TimelineMax } from "gsap";
    //MAGNIFIC POPUP JS
    import 'magnific-popup/dist/jquery.magnific-popup.min.js';
    import 'magnific-popup/dist/magnific-popup.css';
    export default {
        name: 'portfolio2',

        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.initIsotop();
                this.initMagnificPopup();
                this.initScaleImage();
            },

            /*----ISOTOP JS-----*/
            initIsotop() {
                var $container = $('.portfolio-items');
                $container.imagesLoaded(function () {
                    $container.isotope({
                        filter: '*',
                        animationOptions: {
                            duration: 750,
                            easing: 'linear',
                            queue: false
                        }
                    });
                });

                $('.portfolio-filter a').click(function () {
                    $('.portfolio-filter .current').removeClass('current');
                    $(this).addClass('current');
                    var selector = $(this).attr('data-filter');
                    $container.isotope({
                        filter: selector,
                        animationOptions: {
                            duration: 750,
                            easing: 'linear',
                            queue: false
                        }
                    });
                    return false;
                });
            },
            /*----MAGNIFIC POPUP JS-----*/
            initMagnificPopup() {
                if (('.portfolio-items').length > 0) {
                    $('.portfolio-items').each(function () {
                        $(this).magnificPopup({
                            delegate: '.js-zoom-gallery',
                            type: 'image',
                            gallery: {
                                enabled: true
                            }
                        });
                    });
                }
            },
            initScaleImage() {
                var controller = new ScrollMagic.Controller();
                var slides = $('.scale-image');
                for (var i = 0; i < slides.length; i++) {
                    var image = $('img', slides[i]);
                    var tween = TweenMax.to(image, 1, { scale: 1.2 });
                    var scene = new ScrollMagic
                        .Scene({
                            triggerElement: slides[i],
                            duration: "200%",
                            triggerHook: 'onEnter'
                        })
                        .setTween(tween)
                        .addTo(controller);
                }
            }
        }
    }
</script>